// src/pages/batch/components/HistoryGridItem.jsx
import React from "react";
import { Card, Checkbox, Spin, Tooltip, Button, Col, Typography } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { Image as AntImage } from "antd";

const { Text } = Typography;

const HistoryGridItem = ({ item, image, isLoading, onCopy, formatReward, checked, onCheckChange }) => {
  return (
    <Col xs={24} sm={12} md={8} lg={6} xl={4}>
      <Card
        hoverable
        cover={
          <div style={{ height: 180, padding: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
           {isLoading ? (
  <Spin />
) : (
  <AntImage
    alt={item.molecule_id}
    src={image}
    style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
    preview={{ mask: "View" }}
  />
)}
  </div>
        }
        bodyStyle={{ padding: "12px" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
          <div>
            <Text strong>Reward:</Text>
            <Text style={{ marginLeft: 4 }}>{formatReward(item.reward)}</Text>
          </div>
          <Checkbox checked={checked} onChange={onCheckChange} />
        </div>
        <Tooltip title={item.smile}>
          <Text ellipsis style={{ display: "block", marginTop: 4, maxWidth: "calc(100% - 30px)" }}>
            {item.smile}
          </Text>
        </Tooltip>
        <Tooltip title="Copy SMILES">
          <Button
            type="text"
            size="small"
            icon={<CopyOutlined />}
            onClick={() => onCopy(item.smile)}
            style={{ position: "absolute", bottom: 8, right: 8 }}
          />
        </Tooltip>
      </Card>
    </Col>
  );
};

export default HistoryGridItem;